import { formatServicePrice } from '../helpers';
import * as styled from '../styles/services';

type Props = {
  services: Kudable.Service[];
  currency: string | null;
  accentColor: string;
};

export const ServicesList = ({ services, currency, accentColor }: Props) => (
  <styled.Row>
    {services.map((service) => {
      const price = formatServicePrice(service, currency);
      return (
        <styled.Chip key={service.id}>
          <styled.ChipName>{service.name}</styled.ChipName>
          {price && (
            <styled.ChipPrice $accent={accentColor}>{price}</styled.ChipPrice>
          )}
          {service.price_note && (
            <styled.ChipNote>{service.price_note}</styled.ChipNote>
          )}
        </styled.Chip>
      );
    })}
  </styled.Row>
);
